import { render } from "./allLoans.vue?vue&type=template&id=34e825de&scoped=true"
import script from "./allLoans.vue?vue&type=script&lang=js"
export * from "./allLoans.vue?vue&type=script&lang=js"

import "./allLoans.vue?vue&type=style&index=0&id=34e825de&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/raiseloans/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e825de"]])

export default __exports__